
const HeartCrack = () => {
    return (
        <svg aria-hidden width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6354_23944)">
                <rect width="80" height="80" fill="white" fillOpacity="0.01" />
                <rect width="80" height="80" rx="40" fill="#DE332A" fillOpacity="0.12" />
                <g clipPath="url(#clip1_6354_23944)">
                    <path
                        d="M28.2609 21.7895C30.2633 21.4543 32.2828 21.6262 34.1562 22.245L38.4359 28.9051L31.9562 35.3848C31.8273 35.5137 31.75 35.6942 31.7586 35.8832C31.7672 36.0723 31.8445 36.2442 31.982 36.3731L41.607 45.3106C41.8563 45.5426 42.243 45.5598 42.5094 45.3364C42.7758 45.1129 42.8359 44.7348 42.6555 44.4426L37.4648 36.0121L45.2594 29.5153C45.4828 29.3348 45.5602 29.0254 45.4656 28.759L43.5062 23.3106C45.9555 21.8754 48.8687 21.3168 51.7305 21.7981C57.6602 22.7778 62 27.8996 62 33.9067V34.4051C62 37.9715 60.5219 41.3832 57.9094 43.8153L42.3805 58.3129C41.7359 58.9145 40.8852 59.2496 40 59.2496C39.1148 59.2496 38.2641 58.9145 37.6195 58.3129L22.0906 43.8153C19.4781 41.3832 18 37.9715 18 34.4051V33.9067C18 27.8996 22.3398 22.7778 28.2609 21.7895Z"
                        fill="#DE332A"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_6354_23944">
                    <rect width="80" height="80" fill="white" />
                </clipPath>
                <clipPath id="clip1_6354_23944">
                    <rect width="44" height="44" fill="white" transform="translate(18 18)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default HeartCrack;
